import {
  FileMultipleStroke,
  Pencil1Stroke,
  PlusStroke,
  PrinterStroke,
  Search1Stroke,
  Trash3Stroke
} from '@lineiconshq/free-icons';
import { Lineicons } from '@lineiconshq/react-lineicons';
import { TEMPLATE_BASE64 as excelTemplate_tong_hop_hach_toan_phieu_ke_toan_PKT } from '@/lib/templates-base64/PKT';
import { AritoActionBar, AritoActionButton, AritoIcon, AritoMenuButton } from '@/components/custom/erp';
import { downloadBase64Excel } from '@/lib/template-downloader';
import { usePhieuKeToanContext } from '../context';

interface ActionBarProps {
  onAdd?: () => void;
  onEdit?: () => void;
  onDelete?: () => void;
  onCopy?: () => void;
  onPrint?: () => void;
  onSearch?: () => void;
  onRefresh?: () => void;
  onImportFromExcel?: () => void;
  isEditDisabled?: boolean;
}

export default function ActionBar({
  onAdd,
  onEdit,
  onDelete,
  onCopy,
  onPrint,
  onSearch,
  onRefresh,
  onImportFromExcel,
  isEditDisabled = true
}: ActionBarProps) {
  const { exportToExcel, canExport, isExporting, isLoadingImport } = usePhieuKeToanContext();

  const handleDownloadExcelTemplate = () => {
    downloadBase64Excel(excelTemplate_tong_hop_hach_toan_phieu_ke_toan_PKT, 'Phiếu kế toán.xlsx');
  };

  return (
    <AritoActionBar titleComponent={<h1 className='text-xl font-bold'>Phiếu kế toán</h1>}>
      <AritoActionButton title='Thêm' icon={PlusStroke} onClick={onAdd} />
      <AritoActionButton title='Sửa' icon={Pencil1Stroke} onClick={onEdit} disabled={isEditDisabled} />
      <AritoActionButton title='Xóa' icon={Trash3Stroke} onClick={onDelete} disabled={isEditDisabled} />
      <AritoActionButton title='Sao chép' icon={FileMultipleStroke} onClick={onCopy} disabled={isEditDisabled} />
      <AritoMenuButton
        title='In ấn'
        icon={<Lineicons aria-hidden='true' icon={PrinterStroke} size={18} />}
        items={[
          {
            title: 'Mẫu chuẩn',
            icon: <AritoIcon icon={20} />,
            onClick: onPrint
          },
          {
            title: 'Mẫu chuẩn',
            icon: <AritoIcon icon={555} />,
            onClick: onPrint
          }
        ]}
      />
      <AritoActionButton title='Tìm kiếm' icon={Search1Stroke} onClick={onSearch} />

      <AritoMenuButton
        items={[
          {
            title: 'Refresh',
            icon: <AritoIcon icon={15} />,
            onClick: onRefresh,
            group: 1
          },
          {
            title: 'Cố định cột',
            icon: <AritoIcon icon={16} />,
            onClick: () => {},
            group: 1
          },
          {
            title: 'In nhiều',
            icon: <AritoIcon icon={883} />,
            onClick: () => {},
            group: 2
          },
          {
            title: 'Kết xuất dữ liệu',
            icon: <AritoIcon icon={555} />,
            onClick: exportToExcel,
            disabled: !canExport || isExporting,
            loading: isExporting,
            loadingTitle: 'Đang kết xuất...',
            group: 2
          },
          {
            title: 'Tải mẫu Excel',
            icon: <AritoIcon icon={28} />,
            onClick: handleDownloadExcelTemplate,
            group: 3
          },
          {
            title: 'Lấy dữ liệu từ Excel',
            icon: <AritoIcon icon={29} />,
            onClick: onImportFromExcel || (() => {}),
            group: 3
          }
        ]}
      />
    </AritoActionBar>
  );
}
